export const articles = [
  {
    id: 1,
    slug: 'island-economy-enters-a-new-phase-of-growth',
    category: 'Asia',
    label: 'OPINIGURU ORIGINAL',
    title: 'Island economy enters a new phase as confidence and investment return',
    excerpt: 'New indicators point to steadier growth, improving business sentiment and cautious optimism among households.',
    image: 'https://images.unsplash.com/photo-1588598198321-9735fd52455b?auto=format&fit=crop&w=1400&q=85',
    author: 'Nadeesha Perera',
    authorRole: 'Senior Economics Correspondent',
    source: 'Opiniguru',
    date: 'May 18, 2026',
    time: '8:35 AM',
    readTime: '6 min read',
    views: '18.4K',
    featured: true
  },
  {
    id: 2,
    slug: 'parliament-opens-policy-debate',
    category: 'News',
    label: 'ANALYSIS',
    title: 'Parliament opens a consequential week of policy debate',
    excerpt: 'Lawmakers return with economic reforms and public accountability at the centre of the agenda.',
    image: 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?auto=format&fit=crop&w=1000&q=80',
    author: 'Ravi Jayawardena',
    source: 'Opiniguru',
    date: 'May 18, 2026',
    time: '7:50 AM',
    readTime: '4 min read',
    views: '12.8K'
  },
  {
    id: 3,
    slug: 'asia-markets-steady-on-trade-outlook',
    category: 'Business',
    label: 'RSS / SOURCE',
    title: 'Asian markets steady as investors assess the global trade outlook',
    excerpt: 'Regional shares held their ground as investors considered fresh economic and trade signals.',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1000&q=80',
    author: 'Business Desk',
    source: 'Global Market Wire',
    date: 'May 18, 2026',
    time: '7:22 AM',
    readTime: '3 min read',
    views: '10.5K'
  },
  {
    id: 4,
    slug: 'cities-rethink-climate-resilience',
    category: 'Earth',
    label: 'RSS / SOURCE',
    title: 'Cities rethink resilience as extreme weather reshapes urban planning',
    excerpt: 'New investments in infrastructure and community preparedness are changing how cities respond.',
    image: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1000&q=80',
    author: 'World Desk',
    source: 'International News Network',
    date: 'May 18, 2026',
    time: '6:45 AM',
    readTime: '5 min read',
    views: '9.7K'
  },
  {
    id: 5,
    slug: 'responsible-ai-enters-mainstream',
    category: 'Technology',
    label: 'ANALYSIS',
    title: 'Responsible AI moves from policy papers into everyday products',
    excerpt: 'Technology companies are placing safety, transparency and user control closer to product design.',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=80',
    author: 'Maya Fernando',
    source: 'Opiniguru',
    date: 'May 17, 2026',
    time: '9:10 PM',
    readTime: '7 min read',
    views: '16.2K'
  },
  {
    id: 6,
    slug: 'national-side-prepares-for-series',
    category: 'Sport',
    label: 'OPINIGURU ORIGINAL',
    title: 'National side begins final preparations for a defining home series',
    excerpt: 'Selectors are balancing experience and emerging talent ahead of a closely watched contest.',
    image: 'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?auto=format&fit=crop&w=1000&q=80',
    author: 'Dilan Silva',
    source: 'Opiniguru Sport',
    date: 'May 17, 2026',
    time: '6:40 PM',
    readTime: '4 min read',
    views: '14.1K'
  },
  {
    id: 7,
    slug: 'the-case-for-patient-public-leadership',
    category: 'News',
    label: 'OPINION',
    title: 'The case for patient, principled public leadership',
    excerpt: 'Lasting progress depends less on the speed of announcements than on the quality of institutions.',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1000&q=80',
    author: 'Dr. Anjali Wijesinghe',
    authorRole: 'Policy researcher and columnist',
    source: 'Opiniguru',
    date: 'May 17, 2026',
    time: '3:15 PM',
    readTime: '8 min read',
    views: '20.9K'
  },
  {
    id: 8,
    slug: 'coastal-cuisine-finds-new-audience',
    category: 'Travel',
    label: 'OPINIGURU ORIGINAL',
    title: 'Coastal cuisine finds a new audience without losing its roots',
    excerpt: 'A new generation of chefs is celebrating regional ingredients through thoughtful contemporary menus.',
    image: 'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1000&q=80',
    author: 'Shalini de Alwis',
    source: 'Opiniguru',
    date: 'May 17, 2026',
    time: '12:30 PM',
    readTime: '5 min read',
    views: '7.3K'
  },
  {
    id: 9,
    slug: 'independent-cinema-new-global-moment',
    category: 'Arts',
    label: 'ANALYSIS',
    title: 'Independent cinema finds a confident new global moment',
    excerpt: 'Filmmakers are reaching international audiences through festivals and new distribution models.',
    image: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1000&q=80',
    author: 'Kavindu Senanayake',
    source: 'Opiniguru Culture',
    date: 'May 16, 2026',
    time: '8:00 PM',
    readTime: '6 min read',
    views: '8.9K'
  }
];

export const categories = [
  'News',
  'Asia',
  'Europe',
  'Sport',
  'Business',
  'Technology',
  'Health',
  'Culture',
  'Arts',
  'Travel',
  'Earth'
];

export const rssSources = [
  {
    name: 'Global Market Wire',
    category: 'Business',
    country: 'Global',
    active: true,
    updated: '8 min ago',
    imported: 142
  },
  {
    name: 'International News Network',
    category: 'News',
    country: 'Global',
    active: true,
    updated: '12 min ago',
    imported: 284
  },
  {
    name: 'Island Public News',
    category: 'Asia',
    country: 'Sri Lanka',
    active: true,
    updated: '21 min ago',
    imported: 97
  },
  {
    name: 'Regional Sport Desk',
    category: 'Sport',
    country: 'Asia',
    active: false,
    updated: 'Failed 2h ago',
    imported: 63
  }
];

export const findArticle = (slug) => articles.find((article) => article.slug === slug);